// src/core/i18n/translator.ts
import i18n from "i18next";

const createTranslator = (basePath) => {
    return (key) => i18n.t(`${basePath}.${key}`);
};

export const tMapEditor = createTranslator("mapeditor");
export const tMapEditorMap = createTranslator("mapeditor.map");
export const tMapEditorTools = createTranslator("mapeditor.tools");
export const tValidation = createTranslator("validations");
export const tPropertyBar = createTranslator("propertyBar");
export const tRow = createTranslator("propertyBar.row");
export const tShapes = createTranslator("propertyBar.shapes");
export const tZones = createTranslator("propertyBar.zones");
export const tGroup = createTranslator("propertyBar.group");
export const tText = createTranslator("propertyBar.text");
export const tTable = createTranslator("propertyBar.table");
export const tSeat = createTranslator("propertyBar.seat");
export const tIcon = createTranslator("propertyBar.icon");
export const tTooltipSeat = createTranslator("tooltipSeat");